import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { Brain, Zap, FileText, Mail, Shield, Puzzle } from 'lucide-react';

const TABS = [
  { id: 'ai', label: 'AI Configuration', icon: Brain, path: '/settings/ai' },
  { id: 'automation', label: 'Automation', icon: Zap, path: '/settings/automation' },
  { id: 'approvals', label: 'Instructions & Approvals', icon: FileText, path: '/settings/approvals' },
  { id: 'email', label: 'Email', icon: Mail, path: '/settings/email' },
  { id: 'oauth2', label: 'OAuth2', icon: Shield, path: '/settings/oauth2' },
  { id: 'plugins', label: 'Plugins', icon: Puzzle, path: '/settings/plugins' },
];

export default function Settings() {
  const location = useLocation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold">Settings</h1>
        <p className="text-muted-foreground mt-2">Configure application settings and manage the email agent</p>
      </div>

      {/* Sticky Tabs */}
      <div className="sticky top-0 z-10 bg-background -mx-4 sm:-mx-6 px-4 sm:px-6">
        <div className="flex gap-2 overflow-x-auto border-b scrollbar-none">
          {TABS.map(tab => {
            const Icon = tab.icon;
            const isActive = location.pathname === tab.path;
            return (
              <NavLink key={tab.id} to={tab.path}
                className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium whitespace-nowrap transition-colors border-b-2 ${
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground'
                }`}>
                <Icon className="h-4 w-4" />
                {tab.label}
              </NavLink>
            );
          })}
        </div>
      </div>

      <Outlet />
    </div>
  );
}
